import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Box } from '@mui/material';
import { IoClose } from "react-icons/io5";
import ViewPurchaseOrder from './PurchaseOrder';

export default function PurchaseOrderDialog(props) {
 
  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
        sx={{p:3}}
      >
        <Box sx={{position:'absolute',top:5,right:15,cursor:'pointer',fontSize:'20px'}} onClick={()=>props.handleClose()}>
          <IoClose />
        </Box>
       
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
                {
                  props.type==='view'?
                  <ViewPurchaseOrder type={props.type} data={props.data}/>

                  :

                  <ViewPurchaseOrder type={props.type} data={props.data}/> // <PurchaseOrder selectedItem={props.SelectedRows} data={props.data}/>


                }
          </DialogContentText>
        </DialogContent>
       
      </Dialog>
    </React.Fragment>
  );
}
